export default function initScrollStickyCards() {
  window.addEventListener('load', () => {
    const section = document.querySelector('.o-values')
    const listItems = section ? section.querySelectorAll('li') : []
    const stickyContainer = section ? section.querySelector('ul') : null

    if (listItems.length === 0 || !stickyContainer) {
      return
    }

    const PADDING_TOP = 40
    const STICKY_OFFSET = 120
    let SUM_HEIGHT = 0

    listItems.forEach((item, index) => {
      item.style.zIndex = index
      SUM_HEIGHT += item.offsetHeight
    })

    // ⭐ Umożliwia ostatniemu itemowi dojście do swojej pozycji
    stickyContainer.style.minHeight = `${
      SUM_HEIGHT + listItems.length * PADDING_TOP
    }px`

    function handleScroll() {
      const sectionRect = section.getBoundingClientRect()
      const sectionIsSticky = sectionRect.top <= STICKY_OFFSET
      const scrollDepth = STICKY_OFFSET - sectionRect.top
      const lastIndex = listItems.length - 1
      const lastRequiredTop = STICKY_OFFSET + lastIndex * PADDING_TOP

      if (sectionIsSticky) {
        // 🔒 Jeśli ostatnia karta osiągnęła docelowe miejsce, zamrażamy wszystkie
        if (scrollDepth >= lastRequiredTop) {
          listItems.forEach((item, index) => {
            const finalTop = STICKY_OFFSET + index * PADDING_TOP
            item.style.top = `${finalTop}px`
            item.classList.add('is-sticky')
          })
          return
        }

        for (let index = 0; index < listItems.length; index++) {
          const item = listItems[index]
          const requiredTop = STICKY_OFFSET + index * PADDING_TOP

          const rect = item.getBoundingClientRect()
          const distanceToTop = rect.top

          // zmiana gapu między kartami
          if (index > 0) {
            if (distanceToTop === requiredTop) {
              listItems[index - 1].style.gap = '0'
            } else {
              listItems[index - 1].style.gap = '1px'
            }
          }

          // właściwa logika sticky
          if (scrollDepth >= requiredTop) {
            item.style.top = `${requiredTop}px`
            item.classList.add('is-sticky')
          } else {
            item.style.top = `${STICKY_OFFSET}px`
            item.classList.remove('is-sticky')
          }
        }
      } else {
        listItems.forEach((item) => {
          item.style.top = 'unset'
          item.classList.remove('is-sticky')
        })
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()
  })
}
